'use es6';

import namespacedKeyMirror from 'developer-docs-shared-components/lib/utils/namespacedKeyMirror';
import * as EndpointsClient from './api';
export const EndpointsActionTypes = namespacedKeyMirror({
  FETCH_STARTED: null,
  FETCH_SUCCEEDED: null,
  FETCH_FAILED: null
}, 'endpoints');
export function fetchEndpoints() {
  return dispatch => {
    dispatch({
      type: EndpointsActionTypes.FETCH_STARTED
    });
    return EndpointsClient.fetch().then(({
      results
    }) => {
      dispatch({
        type: EndpointsActionTypes.FETCH_SUCCEEDED,
        payload: results
      });
    }).catch(err => {
      dispatch({
        type: EndpointsActionTypes.FETCH_FAILED,
        payload: err
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}